var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown-item',[_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c(_vm.icons[_vm.icon],{tag:"component"}),_c('span',{staticClass:"bold pr-1"},[_vm._v(_vm._s(_vm.title)+" ")]),_c('span',{class:`c-${_vm.getPrimaryColor}four medium`},[_vm._v(_vm._s(_vm.content))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }